import type {FunctionComponent} from 'react';
import {useMemo} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

// Components
import {LandingHeading, LandingParagraph, LandingSection} from '@tempo/landing';
import type {RailItem} from '@app/components/rail';
import {LandingRail} from '@app/components/rail';
import {miscLoader} from '@app/components/Image';

export const MoodRail: FunctionComponent = () => {
	const {t} = useTranslation();

	const MOOD_CONFIG: RailItem[] = useMemo(
		() => [
			{
				src: miscLoader({
					src: '549de347153d55234e026cf58a4ad367.jpg',
					width: 350,
				}),
				trad: t('flowmood_title_focus_standalone-web', {ns: 'flow'}),
			},
			{
				src: miscLoader({
					src: 'daa05bf175590e501a55049d433576c2.jpg',
					width: 350,
				}),
				trad: t('flowmood_title_youandme_standalone-web', {ns: 'flow'}),
			},
			{
				src: miscLoader({
					src: '5ea23b5be9540626721159e36562dba0.jpg',
					width: 350,
				}),
				trad: t('flowmood_title_motivation_standalone-web', {ns: 'flow'}),
			},
			{
				src: miscLoader({
					src: '8293a1bd30460289b27070410fcbf838.jpg',
					width: 350,
				}),
				trad: t('flowmood_title_party_standalone-web', {ns: 'flow'}),
			},
			{
				src: miscLoader({
					src: '83e0a5e084647daa3ca827df81c98de7.jpg',
					width: 350,
				}),
				trad: t('flowmood_title_chill_standalone-web', {ns: 'flow'}),
			},
			{
				src: miscLoader({
					src: '39a8466171f10958e99adc61e4546770.jpg',
					width: 350,
				}),
				trad: t('flowmood_title_melancholy_standalone-web', {ns: 'flow'}),
			},
		],
		[t],
	);

	return (
		<LandingSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'flowlandingpage_title_musiconlyforyouadaptedtomood_standalone-web',
							{ns: 'flow'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'flowlandingpage_text_musiconlyforyouadaptedtomood_standalone-web',
							{ns: 'flow'},
						)}
					</LandingParagraph>{' '}
				</>
			}
		>
			<LandingRail items={MOOD_CONFIG} />
		</LandingSection>
	);
};
